export default {
  alert: {
    fontWeight: 300,
    mb: 4,
  },
};
